import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import React from 'react'
import { RangeElement } from '../../ui-lib/range-element'

export interface LetterSpacingControlProps {
  letterSpacing: number | undefined
  mobileLetterSpacing?: number
  update: (val: number) => void
  mobileUpdate?: (val: number) => void
  wrapperClassName?: string
}

export const LetterSpacingControl = ({
  letterSpacing,
  update,
  mobileUpdate,
  mobileLetterSpacing,
  wrapperClassName,
}: LetterSpacingControlProps) => {
  const { isMobile } = useDeviceModeContext()
  const currentLetterSpacing = isMobile
    ? mobileLetterSpacing || letterSpacing
    : letterSpacing
  const onChange = isMobile ? mobileUpdate || update : update

  return (
    <RangeElement
      wrapperClassName={wrapperClassName}
      label="settings_styles.letter_spacing.label"
      value={currentLetterSpacing ?? 0}
      onChange={onChange}
      max={10}
    />
  )
}
